import { Component, ElementRef, ViewChild } from "@angular/core";
import { Observable } from "rxjs";
import {
    ToastNotification,
    ToastNotificationService,
} from "../../services/toast-notification.service";
import { CommonModule } from "@angular/common";

import { FeatureBaseService } from "../../services/featurebase.service";

@Component({
    selector: "app-toast-container",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./toast-container.component.html",
    styleUrl: "./toast-container.component.scss",
})
export class ToastContainerComponent {
  
    @ViewChild("cfToast")
    cfToast!: ElementRef;
  
    toastMessages$!: Observable<ToastNotification[]>;

    constructor(
        private toastService: ToastNotificationService,
        private _featureBaseService: FeatureBaseService
    ) {
        this.toastMessages$ = this.toastService.toastNotifications$;
    }

    remove(toast: ToastNotification) {
        this.toastService.remove(toast);
    }

    classes(toast: ToastNotification) {
        if (!toast.classList) return "";
        return toast.classList.join(" ");
    }

    handleToastClick() {
        if (Array.from(this.cfToast.nativeElement?.classList).includes("open-intercom")) {
            this._featureBaseService.open();
        }
    }
}
